import '../../core/components/app-root/AppRoot.css';
import '../../styles/textStyle.css';
import '../spin-buttons/SpinButton.css';
import './DateTimePicker.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var clearIconButton = '_1i883gjd-3-15-1';
export var dateSelector = '_1i883gjc-3-15-1';
export var dateTimePicker = _7a468({defaultClassName:'_1i883gj4-3-15-1',variantClassNames:{readOnly:{true:'_1i883gj5-3-15-1'},showError:{true:'_1i883gj6-3-15-1'},disabled:{true:'_1i883gj7-3-15-1'},type:{date:'_1i883gj8-3-15-1',time:'_1i883gj9-3-15-1',datetime:'_1i883gja-3-15-1'}},defaultVariants:{},compoundVariants:[]});
export var spinButtonGroup = '_1i883gjb-3-15-1 _da9a8v0-3-15-1 _da9a8v2-3-15-1 _da9a8v3-3-15-1 _da9a8vb-3-15-1';
export var spinButtonSelectionBackgroundColorVar = 'var(--_1i883gj3-3-15-1)';
export var spinButtonSelectionColorVar = 'var(--_1i883gj2-3-15-1)';